export class HubSiteData {
  public headerEmphasis?: any;
  public themeKey: string;
  public name: string;
  public url: string;
  public logoUrl?: any;
  public usesMetadataNavigation: boolean;
  public megaMenuEnabled: boolean;
  public navigation: Navigation[];
  public siteDesignId: string;
  public requiresJoinApproval: boolean;

  constructor(opt?: Partial<HubSiteData>) {
    Object.assign(this, opt);
  }
}

export interface Navigation {
  Id: number;
  Title: string;
  Url: string;
  IsDocLib: boolean;
  IsExternal: boolean;
  ParentId: number;
  ListTemplateType: number;
  AudienceIds?: any;
  Children: Child[];
}

interface Child {
  Id: number;
  Title: string;
  Url: string;
  IsDocLib: boolean;
  IsExternal: boolean;
  ParentId: number;
  ListTemplateType: number;
  AudienceIds?: any;
  Children: Child[];
}
